import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Col, Input, Row } from 'reactstrap'
import { fetchAllUsers } from 'store/Chats/actions'
import { fetchUsers, fetchUsersExtendedDetails } from 'store/Users/actions'
import '../Chats/style.css'
import Loader from '../Loader'
import Chat from './Chat'
import Conversations from './Conversations'
import NewMessageModal from './NewMessageModal'

const ChatPage = () => {
  const [showNewMessageModal, setShowNewMessageModal] = useState(false)
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [showAddMemberModal, setShowAddMemberModal] = useState(false)
  const dispatch = useDispatch()

  const { allUsers, archivingMessages, groupMembers } = useSelector(
    (store) => store.chat
  )

  const users = useSelector((state) => state.users)

  const groupMemberIds = groupMembers?.map((member) => member?.user_id) || []

  const filteredAllUsers =
    allUsers?.filter((user) => !groupMemberIds?.includes(user?.id)) || []

  const conversations = useSelector((state) => state.chat.conversations) || []

  useEffect(() => {
    dispatch(fetchUsers())
    dispatch(fetchUsersExtendedDetails())
    dispatch(fetchAllUsers())
  }, [dispatch])

  const filteredConversations = conversations.filter((conversation) => {
    const messageUser = conversation?.message_user
      ? JSON.parse(conversation.message_user)
      : {}
    const firstName = messageUser.first_name || ''
    const lastName = messageUser.last_name || ''

    const groupName = conversation?.group_name

    const searchLower = searchTerm.toLowerCase().trim()

    return (
      firstName.toLowerCase().includes(searchLower) ||
      lastName.toLowerCase().includes(searchLower) ||
      groupName?.toLowerCase().includes(searchLower)
    )
  })

  return (
    <>
      <Row className='allContainer'>
        <Col md='5' lg='4' xl='3' className='pl-md-0' style={{paddingRight: "0" }}>
          <Card className='chats scrollbar' style={{ overflowY: 'scroll' }}>
            <div className='chat-buttons d-flex justify-content-between align-items-center'>
              {/* <h4 className='mt-2'>Conversations</h4> */}
              <button
                className='btn btn-info'
                onClick={() => setShowNewMessageModal(true)}
              >
                Compose Message +
              </button>
              <button
                onClick={() => setShowCreateGroupModal(true)}
                className='btn btn-info'
                style={{ zIndex: 50 }}
              >
                New Group
              </button>
            </div>
            <Input
              className='radius10 mt-10 mb-10'
              placeholder='Search conversations'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Conversations conversations={filteredConversations} />
          </Card>
        </Col>
        <Chat setShowAddMemberModal={setShowAddMemberModal} />
      </Row>
      {showNewMessageModal && (
        <NewMessageModal
          users={{ ...users, usersExtendedDetails: allUsers }}
          setshowNewMessageModal={setShowNewMessageModal}
          showNewMessageModal={showNewMessageModal}
        />
      )}
      {showCreateGroupModal && (
        <NewMessageModal
          users={{ ...users, usersExtendedDetails: allUsers }}
          setshowNewMessageModal={setShowCreateGroupModal}
          showNewMessageModal={showCreateGroupModal}
          newGroup={true}
        />
      )}
      {showAddMemberModal && (
        <NewMessageModal
          users={{ ...users, usersExtendedDetails: filteredAllUsers }}
          setshowNewMessageModal={setShowAddMemberModal}
          showNewMessageModal={showAddMemberModal}
          addMember={true}
        />
      )}
      {archivingMessages && (
        <div className='overlay'>
          <Loader />
        </div>
      )}
    </>
  )
}

export default ChatPage
